import { render, staticRenderFns } from "./index.auto.vue?vue&type=template&id=b47b769e"
import script from "./index.auto.vue?vue&type=script&lang=js"
export * from "./index.auto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports